<div>
  <h1 mat-dialog-title>{{data.pojasnjenje}}</h1>
  <div mat-dialog-content class="col-12" >{{data.pitanje}}</div>
  <hr />
  <div mat-dialog-actions class="col-12 d-flex justify-content-center">
    <button mat-button [mat-dialog-close]="true" class="ok-color"><mat-icon aria-hidden="false" aria-label="DA">check</mat-icon> Da</button>
    <button mat-button mat-dialog-close class="cancel-color"><mat-icon aria-hidden="false" aria-label="Ne">cancel</mat-icon> Ne</button>
  </div>
</div>
